import examStore from "@/packages/exams/examStore";
import examLinks from "@/packages/exams/examLinks";
import examRoutes from "@/packages/exams/examRoutes";
import {
  deferralRoutes,
  deferralStore,
} from "@/packages/exams/modules/Deferrals";
import {
  withdrawalRoutes,
  withdrawalStore,
} from "@/packages/exams/modules/Withdrawals";
import { RemarkRoutes, RemarkStore } from "@/packages/exams/modules/Remark";

export default {
  install(Vue, options) {
    options.router.addRoute(...examRoutes);
    options.router.addRoute(...deferralRoutes);
    options.router.addRoute(...withdrawalRoutes);
    options.router.addRoute(...RemarkRoutes);
    options.store.registerModule("Exam", examStore);
    options.store.registerModule("Deferral", deferralStore);
    options.store.registerModule("Withdrawal", withdrawalStore);
    options.store.registerModule("Remark", RemarkStore);
    options.store.commit("Dashboard/SET_LINKS", examLinks);
  },
};
